import { buildUrl, getDSPId } from "../ReusableFunctions/reusableFunctions";
import { SERVER_URLS } from "../appConstants";
import { getToken } from "./authentication";

export const getSubscriptionDetails = async () => {
    return new Promise(async (resolve, reject) => {
        try {
          let data;
          const token = getToken();
          const response = await fetch(
            `${SERVER_URLS.BACKEND_SERVER}/dsp/subscription`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response.ok && response.status === 200) {
            data = await response.json();
            resolve(data);
          } else if (response.status === 204) {
            resolve({ requests: [] });
          } else {
            reject(data?.message || "Something went wrong while getting subscription.");
          }
        } catch (error) {
          console.log(error);
          reject("Something went wrong while getting subscription.");
        }
    });
}

export const getAllSubscriptionPlans = async (typeParam) => {
  return new Promise(async (resolve, reject) => {
      try {
        let data;
        const token = getToken();
        const response = await fetch(
          `${SERVER_URLS.BACKEND_SERVER}/dsp/subscription/plans${typeParam ? `?type=${typeParam}` : ""}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.ok && response.status === 200) {
          data = await response.json();
          resolve(data);
        } else if (response.status === 204) {
          resolve({ requests: [] });
        } else {
          reject(data?.message || "Something went wrong while getting subscription plans.");
        }
      } catch (error) {
        console.log(error);
        reject("Something went wrong while getting subscription plans.");
      }
  });
}


export const assignSubPlan = async (subscriptionData) => {
  return new Promise(async (resolve, reject) => {
      try {
        let data;
        const token = getToken();
        const response = await fetch(
          `${SERVER_URLS.BACKEND_SERVER}/dsp/subscription/assignSubPlan`,
          {
            method: "POST",
            body: JSON.stringify(subscriptionData),
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            },
          }
        );
        if (response.ok && response.status === 200) {
          data = await response.json();
          resolve(data);
        } else if (response.status === 204) {
          resolve({ requests: [] });
        } else {
          reject(data?.message || "Something went wrong while assigning subscription plans.");
        }
      } catch (error) {
        console.log(error);
        reject("Something went wrong while assigning subscription plans.");
      }
  });
}

export const confirmSubscriptionAfterPayment = async (subscriptionData) => {
  return new Promise(async (resolve, reject) => {
    try {
      const token = getToken();

      const response = await fetch(
        `${SERVER_URLS.BACKEND_SERVER}/dsp/subscription/confirmSubscriptionAfterPayment`,
        {
          method: "POST",
          body: JSON.stringify(subscriptionData),
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok && response.status === 200) {
        const data = await response.json();
        resolve(data);
      } else if (response.status === 204) {
        resolve({ message: "No data returned" });
      } else {
        const err = await response.json().catch(() => ({}));
        reject(err?.message || "Something went wrong while confirming subscription.");
      }
    } catch (error) {
      console.error("Error confirming subscription:", error);
      reject("Something went wrong while confirming subscription.");
    }
  });
};
